import dynamic from "next/dynamic";

export const DynamicLayoutWidget081 = dynamic(
  () => import("./LayoutWidget081"),
  {
    suspense: true,
  }
);
